import React from 'react'

import GooglePlacePin, {
  GoogleMarkerType,
  GoogleMarkerTypes,
} from './GooglePlacePin'

import { ExploreCategory } from 'tripPlanner/pages/trip/Explore/common'

const categoryPinTypes: Record<ExploreCategory['label'], GoogleMarkerType> = {
  'Top attractions': GoogleMarkerTypes.outdoor,
  Restaurants: GoogleMarkerTypes.food,
  Cafes: GoogleMarkerTypes.food,
  Parks: GoogleMarkerTypes.outdoor,
  Shopping: GoogleMarkerTypes.retail,
  Museums: GoogleMarkerTypes.entertainment,
  Sports: GoogleMarkerTypes.entertainment,
  Bars: GoogleMarkerTypes.food,
}

interface Props
  extends Omit<
    React.ComponentProps<typeof GooglePlacePin>,
    'type' | 'children'
  > {
  category: ExploreCategory
  saved?: boolean
}

function ExplorePin({ category, saved, ...props }: Props) {
  const Icon = category.icon
  return (
    <GooglePlacePin
      type={categoryPinTypes[category.label]}
      size={saved ? 'large' : 'small'}
      {...props}
    >
      <Icon colour="neutral-eight" />
    </GooglePlacePin>
  )
}

export default ExplorePin
